import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { basePspPriceListEffects, basePspPriceListReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('pspPriceList', basePspPriceListReducer.BasePspPriceListReducer),
    EffectsModule.forFeature([basePspPriceListEffects.BasePspPriceListEffects]),
  ],
})
export class BasePspPriceListStoreModule {}
